/* tslint:disable */
/* eslint-disable */
/**
 * Revisdom API
 * Revisdom uygulaması için REST API dokümantasyonu
 *
 * The version of the OpenAPI document: v1
 * Contact: support@revisdom.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RevisdomAPIViewModelsEntryProjectListResponse } from './RevisdomAPIViewModelsEntryProjectListResponse';
import {
    RevisdomAPIViewModelsEntryProjectListResponseFromJSON,
    RevisdomAPIViewModelsEntryProjectListResponseFromJSONTyped,
    RevisdomAPIViewModelsEntryProjectListResponseToJSON,
    RevisdomAPIViewModelsEntryProjectListResponseToJSONTyped,
} from './RevisdomAPIViewModelsEntryProjectListResponse';

/**
 * API yanıtları için genel response modeli
 * @export
 * @interface ApiResponse1ProjectListResponse
 */
export interface ApiResponse1ProjectListResponse {
    /**
     * İşlemin başarılı olup olmadığını belirtir
     * @type {boolean}
     * @memberof ApiResponse1ProjectListResponse
     */
    success?: boolean;
    /**
     * İşlem sonucu hakkında bilgi mesajı
     * @type {string}
     * @memberof ApiResponse1ProjectListResponse
     */
    message?: string | null;
    /**
     * 
     * @type {RevisdomAPIViewModelsEntryProjectListResponse}
     * @memberof ApiResponse1ProjectListResponse
     */
    data?: RevisdomAPIViewModelsEntryProjectListResponse;
    /**
     * Hata durumunda hata detayları
     * @type {{ [key: string]: Array<string>; }}
     * @memberof ApiResponse1ProjectListResponse
     */
    errors?: { [key: string]: Array<string>; } | null;
}

/**
 * Check if a given object implements the ApiResponse1ProjectListResponse interface.
 */
export function instanceOfApiResponse1ProjectListResponse(value: object): value is ApiResponse1ProjectListResponse {
    return true;
}

export function ApiResponse1ProjectListResponseFromJSON(json: any): ApiResponse1ProjectListResponse {
    return ApiResponse1ProjectListResponseFromJSONTyped(json, false);
}

export function ApiResponse1ProjectListResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiResponse1ProjectListResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'success': json['success'] == null ? undefined : json['success'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : RevisdomAPIViewModelsEntryProjectListResponseFromJSON(json['data']),
        'errors': json['errors'] == null ? undefined : json['errors'],
    };
}

export function ApiResponse1ProjectListResponseToJSON(json: any): ApiResponse1ProjectListResponse {
    return ApiResponse1ProjectListResponseToJSONTyped(json, false);
}

export function ApiResponse1ProjectListResponseToJSONTyped(value?: ApiResponse1ProjectListResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'success': value['success'],
        'message': value['message'],
        'data': RevisdomAPIViewModelsEntryProjectListResponseToJSON(value['data']),
        'errors': value['errors'],
    };
}

